import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MicrosoftTeamsUserResult } from '../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TeamsCallQueueTeamsUsersSearchResource {
  private _httpClient = inject(HttpClient);

  search(
    tenantId: string,
    query: string,
    enterpriseVoiceEnabled?: boolean,
    limit = 250,
    accountType = 'ALL',
  ): Observable<MicrosoftTeamsUserResult[]> {
    let params = `q=${encodeURIComponent(query)}&accountType=${accountType}`;
    if (limit != null) {
      params += `&limit=${limit}`;
    }
    if (enterpriseVoiceEnabled != null) {
      params += `&enterpriseVoiceEnabled=${enterpriseVoiceEnabled}`;
    }
    return this._httpClient.get<MicrosoftTeamsUserResult[]>(
      `/services/microsoft/call-queue-management/tenants/${tenantId}/teams-users/search?${params}`,
    );
  }
}
